exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bistro-weborders-body-with-items[data-v-30e2500f]{padding-top:10vh;padding-bottom:16vh;height:80%}.bistro-weborders-body[data-v-30e2500f]{padding-top:40vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-30e2500f","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Checkout.vue
// module id = 391
// module chunks = 0